import React, { useState } from 'react'
import { sendDataLayer } from '../../utils/functions'

import Icon from './Icon'

function Accordeon({
  title, 
  content
}) {
  const [show, setShow] = useState(false)

  // Cada item maneja su propio estado: abrir uno no cierra los demás
  const toggler = () => {
    if (show) {
      setShow(false)
      return
    }

    setShow(true)
    sendDataLayer({datalayer: {event: 'frequently_questions',question: title},repeat: true})
  }

  return (
    <div className={`mc-accordeon-container slow_ani ${show ? 'active' : ''}`}>
      <div
        className="mc-accordeon-toggle slow_ani"
        onClick={toggler}
      >
        {title}
        <div className="mc-accordeon-toggle-icon">
          <Icon name={show ? 'less': 'more'} />
        </div>
      </div>
      {show &&
        <div className="mc-accordeon-content">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      }
    </div>
  )
}

export default Accordeon
